import { graphql } from '../../graphql/generated';

export const PATIENT_REGISTRATION_QUERY = graphql(`
  query PatientRegistration($id: ID!) {
    doctor(id: $id) {
      id
      insurances {
        id
        shortName
        name
        code
      }
      flipParamNames
    }

    insurances {
      id
      code
      shortName
      name
    }
  }
`);

export const PATIENT_BY_SVNR_SEARCH_QUERY = graphql(`
  query PATIENT_BY_SVNR_SEARCH($svnr: String!) {
    newestRequestBySvnr(svnr: $svnr) {
      patientData {
        city
        country
        street
        zip
        phone
        email
        gender
        idCardAuthority
        idCardNumber
        idCardType
        insuredPerson {
          city
          country
          street
          zip
          phone
          email
          gender
        }
      }
    } #
  }
`);

export const PATIENT_REGISTRATION_LOCK_QUERY = graphql(`
  query PatientRegistrationLock($id: ID!) {
    request(id: $id) {
      id
      patientDataFromAis
    }
  }
`);
